<template>
    <Transition name="modal-fade">
      <div v-show="isdisplay" class="cf-overlay" @click.self="close">
        <Transition name="modal-slide">
          <div v-show="isdisplay" class="cf-dialog cf-dialog--xxl">

                <!-- Header -->
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-printer-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">Aperçu avant impression</h4>
                            <p class="cf-modal-head__sub">{{ titlemodal }}</p>
                        </div>
                    </div>
                    <div class="flex items-center gap-2">
                        <button @click="showSettings = !showSettings"
                                class="ti-btn ti-btn-sm"
                                :class="showSettings ? 'ti-btn-primary' : 'ti-btn-outline-primary'"
                                :title="showSettings ? 'Masquer les paramètres' : 'Afficher les paramètres'"
                        >
                            <i :class="showSettings ? 'ri-settings-fill' : 'ri-settings-line'" class="mr-1"></i>
                            <span class="hidden sm:inline">{{ showSettings ? 'Masquer' : 'Paramètres' }}</span>
                            <i :class="showSettings ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'" class="ml-1"></i>
                        </button>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>
                </div>

                <!-- Body -->
                <div class="cf-dialog-body">
                    <div class="box overflow-hidden">
                        <!-- En-tête avec titre et actions rapides -->
                        <div class="box-header justify-between hidden">
                            <div class="box-title">{{ titlemodal }}</div>
                            <div class="flex gap-8 ">
                                <button @click="resetToDefaults(typeimpression)" class="ti-btn ti-btn-light ti-btn-sm" title="Réinitialiser">
                                    <i class="ri-refresh-line"></i>
                                </button>
                                <button @click="saveAsDefault" class="ti-btn ti-btn-info ti-btn-sm" title="Sauvegarder comme défaut">
                                    <i class="ri-save-line mr-1"></i> Défaut
                                </button>
                            </div>
                        </div>

                        <div class="box-body">
                            <!-- Section des paramètres avec transition -->
                            <transition name="slide-fade">
                                <div v-show="showSettings" class="settings-panel mb-4">
                                    <!-- Barre d'outils rapide toujours visible -->
                                    <div class="quick-toolbar flex flex-wrap items-center gap-2 p-3 bg-gray-50 border rounded-lg mb-4">
                                        <span class="text-sm font-medium text-gray-600">Rapide:</span>

                                        <!-- Format rapide -->
                                        <select v-model="selectedFormat" @change="updateFormatSettings" class="form-control form-control-sm w-auto">
                                            <option v-for="format in printFormats" :key="format.id" :value="format.id">
                                                {{ format.name }}
                                            </option>
                                        </select>

                                        <!-- Taille police rapide -->
                                        <div class="flex items-center gap-1">
                                            <button @click="decreaseFontSize" class="ti-btn ti-btn-light ti-btn-xs">
                                                <i class="ri-subtract-line"></i>
                                            </button>
                                            <span class="text-sm w-12 text-center">{{ fontSize }}px</span>
                                            <button @click="increaseFontSize" class="ti-btn ti-btn-light ti-btn-xs">
                                                <i class="ri-add-line"></i>
                                            </button>
                                        </div>

                                        <!-- Toggle filigrane rapide -->
                                        <label class="toggle-switch">
                                            <input type="checkbox" v-model="watermark.enabled">
                                            <span class="toggle-slider"></span>
                                            <span class="toggle-label">Filigrane</span>
                                        </label>

                                        <!-- Copies -->
                                        <select v-model="copiesPerPage" class="form-control form-control-sm w-auto">
                                            <option v-for="num in availableCopies" :key="num" :value="num">
                                                {{ num }} copie(s)
                                            </option>
                                        </select>
                                    </div>

                                    <!-- Onglets de configuration -->
                                    <div class="border-b mb-4">
                                        <nav class="flex gap-1 flex-wrap">
                                            <button
                                                    v-for="tab in configTabs"
                                                    :key="tab.id"
                                                    @click="activeTab = tab.id"
                                                    :class="[
                                                    'px-3 py-2 text-sm font-medium rounded-t-lg transition-colors',
                                                    activeTab === tab.id
                                                        ? 'bg-primary text-white'
                                                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                                                ]"
                                            >
                                                <i :class="tab.icon + ' mr-1'"></i>
                                                <span class="hidden sm:inline">{{ tab.name }}</span>
                                            </button>
                                        </nav>
                                    </div>

                                    <!-- Tab: Format -->
                                    <div v-show="activeTab === 'format'" class="config-panel">
                                        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 p-4 border rounded-lg bg-gray-50">
                                            <div class="space-y-2">
                                                <label class="ti-form-label mb-0">Catégorie</label>
                                                <select v-model="selectedCategory" @change="onCategoryChange" class="form-control">
                                                    <option v-for="cat in formatCategories" :key="cat.id" :value="cat.id">
                                                        {{ cat.name }}
                                                    </option>
                                                </select>
                                            </div>

                                            <div class="space-y-2">
                                                <label class="ti-form-label mb-0">Format</label>
                                                <select v-model="selectedFormat" @change="updateFormatSettings" class="form-control">
                                                    <option v-for="format in filteredFormats" :key="format.id" :value="format.id">
                                                        {{ format.name }}
                                                    </option>
                                                </select>
                                            </div>

                                            <div v-if="showOrientationOption" class="space-y-2">
                                                <label class="ti-form-label mb-0">Orientation</label>
                                                <select v-model="orientation" class="form-control">
                                                    <option value="portrait">Portrait</option>
                                                    <option value="landscape">Paysage</option>
                                                </select>
                                            </div>

                                            <div class="space-y-2">
                                                <label class="ti-form-label mb-0">Tickets par feuille</label>
                                                <select v-model="copiesPerPage" class="form-control">
                                                    <option v-for="num in availableCopies" :key="num" :value="num">
                                                        {{ num }} {{ num > 1 ? 'copies' : 'copie' }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Tab: Police & Style -->
                                    <div v-show="activeTab === 'style'" class="config-panel">
                                        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-4 border rounded-lg bg-gray-50">
                                            <div class="space-y-2">
                                                <label class="ti-form-label mb-0">Police</label>
                                                <select v-model="fontFamily" class="form-control">
                                                    <option v-for="font in availableFonts" :key="font.value" :value="font.value">
                                                        {{ font.name }}
                                                    </option>
                                                </select>
                                            </div>

                                            <div class="space-y-2">
                                                <label class="ti-form-label mb-0">Taille de police: {{ fontSize }}px</label>
                                                <div class="flex items-center gap-2">
                                                    <button @click="decreaseFontSize" class="ti-btn ti-btn-light ti-btn-sm">
                                                        <i class="ri-subtract-line"></i>
                                                    </button>
                                                    <input
                                                            v-model.number="fontSize"
                                                            type="range"
                                                            :min="fontSizeRange.min"
                                                            :max="fontSizeRange.max"
                                                            step="1"
                                                            class="flex-1"
                                                    >
                                                    <button @click="increaseFontSize" class="ti-btn ti-btn-light ti-btn-sm">
                                                        <i class="ri-add-line"></i>
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="space-y-2">
                                                <label class="ti-form-label mb-0">Épaisseur</label>
                                                <select v-model="fontWeight" class="form-control">
                                                    <option value="300">Léger</option>
                                                    <option value="400">Normal</option>
                                                    <option value="500">Medium</option>
                                                    <option value="600">Semi-gras</option>
                                                    <option value="700">Gras</option>
                                                </select>
                                            </div>

                                            <div class="space-y-2">
                                                <label class="ti-form-label mb-0">Interligne: {{ lineHeight }}</label>
                                                <input
                                                        v-model.number="lineHeight"
                                                        type="range"
                                                        min="1"
                                                        max="2"
                                                        step="0.1"
                                                        class="w-full"
                                                >
                                            </div>

                                            <div class="space-y-2">
                                                <label class="ti-form-label mb-0">Marges: {{ margins }}mm</label>
                                                <input
                                                        v-model.number="margins"
                                                        type="range"
                                                        min="0"
                                                        max="20"
                                                        step="1"
                                                        class="w-full"
                                                >
                                            </div>

                                            <div class="space-y-2">
                                                <label class="ti-form-label mb-0">Densité</label>
                                                <select v-model="density" class="form-control">
                                                    <option value="compact">Compact</option>
                                                    <option value="normal">Normal</option>
                                                    <option value="comfortable">Confortable</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Tab: Contenu -->
                                    <div v-show="activeTab === 'content'" class="config-panel">
                                        <div class="p-4 border rounded-lg bg-gray-50">
                                            <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                                                <label v-for="opt in contentOptions" :key="opt.key" class="flex items-center gap-2 cursor-pointer">


                                                    <!--input v-if="opt.disabled"
                                                            disabled
                                                            type="checkbox"
                                                             value="true"
                                                            class="ti-form-checkbox"
                                                    >

                                                    <input v-else
                                                            type="checkbox"
                                                            v-model="options[opt.key]"
                                                            class="ti-form-checkbox"
                                                    -->


                                                    <input
                                                            type="checkbox"
                                                            :checked="options[opt.key]"
                                                            :disabled="opt.disabled"
                                                            @change="handleOptionChange(opt, $event)"
                                                            class="ti-form-checkbox"
                                                    >
                                                    <span class="text-sm">{{ opt.label }}</span>
                                                </label>
                                            </div>

                                            <div v-if="options.showFooter" class="mt-4 space-y-2">
                                                <label class="ti-form-label mb-0">Message de pied de page</label>
                                                <input
                                                        v-model="customFooterText"
                                                        type="text"
                                                        class="form-control"
                                                        placeholder="Merci de votre visite !"
                                                >
                                            </div>

                                            <div v-if="options.showLogo" class="mt-4 space-y-2">
                                                <label class="ti-form-label mb-0">Taille du logo</label>
                                                <div class="flex items-center gap-4">
                                                    <input
                                                            v-model.number="logoSize.width"
                                                            type="number"
                                                            class="form-control w-24"
                                                            placeholder="Largeur"
                                                    >
                                                    <span>×</span>
                                                    <input
                                                            v-model.number="logoSize.height"
                                                            type="number"
                                                            class="form-control w-24"
                                                            placeholder="Hauteur"
                                                    >
                                                    <span class="text-sm text-gray-500">px</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Tab: Couleurs -->
                                    <div v-show="activeTab === 'colors'" class="config-panel">
                                        <div class="p-4 border rounded-lg bg-gray-50 space-y-4">
                                            <!-- Thèmes prédéfinis -->
                                            <div>
                                                <label class="ti-form-label mb-2 flex items-center gap-2">
                                                    <i class="ri-magic-line text-purple-500"></i>
                                                    Thèmes prédéfinis
                                                </label>
                                                <div class="flex flex-wrap gap-2">
                                                    <button
                                                            v-for="preset in colorPresets"
                                                            :key="preset.name"
                                                            @click="applyColorPreset(preset)"
                                                            class="flex items-center gap-1 px-3 py-1.5 rounded-full border text-sm font-medium transition-all hover:shadow-md"
                                                            :style="{ backgroundColor: preset.colors.ticketBg, color: preset.colors.storeName, borderColor: preset.colors.borderColor }"
                                                    >
                                                        {{ preset.icon }} {{ preset.name }}
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="border-t pt-4">
                                                <label class="ti-form-label mb-3 flex items-center gap-2">
                                                    <i class="ri-brush-line text-blue-500"></i>
                                                    Personnalisation par section
                                                </label>

                                                <!-- Grille de sélecteurs -->
                                                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">

                                                    <!-- En-tête magasin -->
                                                    <div class="color-group p-3 rounded-lg border bg-white">
                                                        <p class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                                                            <i class="ri-store-2-line mr-1"></i> En-tête magasin
                                                        </p>
                                                        <div class="space-y-2">
                                                            <div class="color-picker-row">
                                                                <label>Nom magasin</label>
                                                                <div class="color-input-pair">
                                                                    <input type="color" v-model="colors.storeName" class="color-swatch">
                                                                    <input type="text" v-model="colors.storeName" class="color-hex">
                                                                </div>
                                                            </div>
                                                            <div class="color-picker-row">
                                                                <label>Infos (adresse, tél)</label>
                                                                <div class="color-input-pair">
                                                                    <input type="color" v-model="colors.storeInfo" class="color-swatch">
                                                                    <input type="text" v-model="colors.storeInfo" class="color-hex">
                                                                </div>
                                                            </div>
                                                            <div class="color-picker-row">
                                                                <label>Type document</label>
                                                                <div class="color-input-pair">
                                                                    <input type="color" v-model="colors.docType" class="color-swatch">
                                                                    <input type="text" v-model="colors.docType" class="color-hex">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Transaction -->
                                                    <div class="color-group p-3 rounded-lg border bg-white">
                                                        <p class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                                                            <i class="ri-file-text-line mr-1"></i> Infos transaction
                                                        </p>
                                                        <div class="space-y-2">
                                                            <div class="color-picker-row">
                                                                <label>Labels (Date:, Client:)</label>
                                                                <div class="color-input-pair">
                                                                    <input type="color" v-model="colors.labelText" class="color-swatch">
                                                                    <input type="text" v-model="colors.labelText" class="color-hex">
                                                                </div>
                                                            </div>
                                                            <div class="color-picker-row">
                                                                <label>Valeurs</label>
                                                                <div class="color-input-pair">
                                                                    <input type="color" v-model="colors.valueText" class="color-swatch">
                                                                    <input type="text" v-model="colors.valueText" class="color-hex">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Tableau articles -->
                                                    <div class="color-group p-3 rounded-lg border bg-white">
                                                        <p class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                                                            <i class="ri-table-line mr-1"></i> Tableau articles
                                                        </p>
                                                        <div class="space-y-2">
                                                            <div class="color-picker-row">
                                                                <label>Fond en-tête</label>
                                                                <div class="color-input-pair">
                                                                    <input type="color" v-model="colors.tableHeaderBg" class="color-swatch">
                                                                    <input type="text" v-model="colors.tableHeaderBg" class="color-hex">
                                                                </div>
                                                            </div>
                                                            <div class="color-picker-row">
                                                                <label>Texte en-tête</label>
                                                                <div class="color-input-pair">
                                                                    <input type="color" v-model="colors.tableHeaderText" class="color-swatch">
                                                                    <input type="text" v-model="colors.tableHeaderText" class="color-hex">
                                                                </div>
                                                            </div>
                                                            <div class="color-picker-row">
                                                                <label>Texte lignes</label>
                                                                <div class="color-input-pair">
                                                                    <input type="color" v-model="colors.tableBodyText" class="color-swatch">
                                                                    <input type="text" v-model="colors.tableBodyText" class="color-hex">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Totaux -->
                                                    <div class="color-group p-3 rounded-lg border bg-white">
                                                        <p class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                                                            <i class="ri-money-dollar-circle-line mr-1"></i> Lignes totaux
                                                        </p>
                                                        <div class="space-y-2">
                                                            <div class="color-picker-row">
                                                                <label>Fond total</label>
                                                                <div class="color-input-pair">
                                                                    <input type="color" v-model="colors.totalBg" class="color-swatch">
                                                                    <input type="text" v-model="colors.totalBg" class="color-hex">
                                                                </div>
                                                            </div>
                                                            <div class="color-picker-row">
                                                                <label>Fond "Net à payer"</label>
                                                                <div class="color-input-pair">
                                                                    <input type="color" v-model="colors.netBg" class="color-swatch">
                                                                    <input type="text" v-model="colors.netBg" class="color-hex">
                                                                </div>
                                                            </div>
                                                            <div class="color-picker-row">
                                                                <label>Texte "Net à payer"</label>
                                                                <div class="color-input-pair">
                                                                    <input type="color" v-model="colors.netText" class="color-swatch">
                                                                    <input type="text" v-model="colors.netText" class="color-hex">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Mise en page -->
                                                    <div class="color-group p-3 rounded-lg border bg-white">
                                                        <p class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                                                            <i class="ri-layout-4-line mr-1"></i> Mise en page
                                                        </p>
                                                        <div class="space-y-2">
                                                            <div class="color-picker-row">
                                                                <label>Pied de page</label>
                                                                <div class="color-input-pair">
                                                                    <input type="color" v-model="colors.footerText" class="color-swatch">
                                                                    <input type="text" v-model="colors.footerText" class="color-hex">
                                                                </div>
                                                            </div>
                                                            <div class="color-picker-row">
                                                                <label>Séparateurs</label>
                                                                <div class="color-input-pair">
                                                                    <input type="color" v-model="colors.dividerColor" class="color-swatch">
                                                                    <input type="text" v-model="colors.dividerColor" class="color-hex">
                                                                </div>
                                                            </div>
                                                            <div class="color-picker-row">
                                                                <label>Fond ticket</label>
                                                                <div class="color-input-pair">
                                                                    <input type="color" v-model="colors.ticketBg" class="color-swatch">
                                                                    <input type="text" v-model="colors.ticketBg" class="color-hex">
                                                                </div>
                                                            </div>
                                                            <div class="color-picker-row">
                                                                <label>Bordure ticket</label>
                                                                <div class="color-input-pair">
                                                                    <input type="color" v-model="colors.borderColor" class="color-swatch">
                                                                    <input type="text" v-model="colors.borderColor" class="color-hex">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Tab: Filigrane (NOUVEAU) -->
                                    <div v-show="activeTab === 'watermark'" class="config-panel">
                                        <div class="p-4 border rounded-lg bg-gray-50">
                                            <!-- Activation du filigrane -->
                                            <div class="flex items-center justify-between mb-4 pb-4 border-b">
                                                <div>
                                                    <h6 class="font-semibold">Activer le filigrane</h6>
                                                    <p class="text-sm text-gray-500">Affiche un texte en arrière-plan du ticket</p>
                                                </div>
                                                  <label class="toggle-switch">
                                                    <input type="checkbox" v-model="watermark.enabled">
                                                    <span class="toggle-slider"></span>
                                                    <!--span class="toggle-label">Filigrane</span-->
                                                </label>

                                            </div>

                                            <div v-if="watermark.enabled" class="space-y-4">
                                                <!-- Texte du filigrane -->
                                                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                    <div class="space-y-2">
                                                        <label class="ti-form-label mb-0">Texte du filigrane</label>
                                                        <input
                                                                v-model="watermark.text"
                                                                type="text"
                                                                class="form-control"
                                                                placeholder="Ex: COPIE, PAYÉ, ANNULÉ..."
                                                        >
                                                    </div>

                                                    <div class="space-y-2">
                                                        <label class="ti-form-label mb-0">Textes prédéfinis</label>
                                                        <div class="flex flex-wrap gap-2">
                                                            <button
                                                                    v-for="preset in watermarkPresets"
                                                                    :key="preset"
                                                                    @click="watermark.text = preset"
                                                                    :class="[
                                                                    'ti-btn ti-btn-xs',
                                                                    watermark.text === preset ? 'ti-btn-primary' : 'ti-btn-outline-primary'
                                                                ]"
                                                            >
                                                                {{ preset }}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Style du filigrane -->
                                                <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                                                    <div class="space-y-2">
                                                        <label class="ti-form-label mb-0">Taille: {{ watermark.fontSize }}px</label>
                                                        <input
                                                                v-model.number="watermark.fontSize"
                                                                type="range"
                                                                min="20"
                                                                max="120"
                                                                step="5"
                                                                class="w-full"
                                                        >
                                                    </div>

                                                    <div class="space-y-2">
                                                        <label class="ti-form-label mb-0">Opacité: {{ watermark.opacity }}%</label>
                                                        <input
                                                                v-model.number="watermark.opacity"
                                                                type="range"
                                                                min="5"
                                                                max="50"
                                                                step="5"
                                                                class="w-full"
                                                        >
                                                    </div>

                                                    <div class="space-y-2">
                                                        <label class="ti-form-label mb-0">Rotation: {{ watermark.rotation }}°</label>
                                                        <input
                                                                v-model.number="watermark.rotation"
                                                                type="range"
                                                                min="-90"
                                                                max="90"
                                                                step="15"
                                                                class="w-full"
                                                        >
                                                    </div>
                                                </div>

                                                <!-- Couleur et position -->
                                                <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                                                    <div class="space-y-2">
                                                        <label class="ti-form-label mb-0">Couleur</label>
                                                        <div class="flex items-center gap-2">
                                                            <input
                                                                    v-model="watermark.color"
                                                                    type="color"
                                                                    class="w-10 h-10 rounded cursor-pointer border"
                                                            >
                                                            <input
                                                                    v-model="watermark.color"
                                                                    type="text"
                                                                    class="form-control flex-1"
                                                                    placeholder="#000000"
                                                            >
                                                        </div>
                                                    </div>

                                                    <div class="space-y-2">
                                                        <label class="ti-form-label mb-0">Position verticale</label>
                                                        <select v-model="watermark.position" class="form-control">
                                                            <option value="center">Centre</option>
                                                            <option value="top">Haut</option>
                                                            <option value="bottom">Bas</option>
                                                        </select>
                                                    </div>

                                                    <div class="space-y-2">
                                                        <label class="ti-form-label mb-0">Répétition</label>
                                                        <select v-model="watermark.repeat" class="form-control">
                                                            <option value="single">Une seule fois</option>
                                                            <option value="repeat">Répéter (motif)</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <!-- Aperçu du filigrane -->
                                                <div class="mt-4 p-4 border rounded bg-white">
                                                    <label class="ti-form-label mb-2">Aperçu du filigrane</label>
                                                    <div
                                                            class="relative h-24 border rounded flex items-center justify-center overflow-hidden"
                                                            :style="{ backgroundColor: '#f9fafb' }"
                                                    >
                                                        <span
                                                                class="watermark-preview"
                                                                :style="watermarkPreviewStyle"
                                                        >
                                                            {{ watermark.text || 'FILIGRANE' }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Tab: Avancé -->
                                    <div v-show="activeTab === 'advanced'" class="config-panel">
                                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 border rounded-lg bg-gray-50">

                                            <!-- Options d'impression automatique -->
                                            <div class="space-y-4 md:col-span-2 pb-4 border-b">
                                                <div class="flex items-center justify-between">
                                                    <div>
                                                        <h6 class="font-semibold flex items-center gap-2">
                                                            <i class="ri-flashlight-line text-yellow-500"></i>
                                                            Impression automatique
                                                        </h6>
                                                        <p class="text-sm text-gray-500">Lance l'impression automatiquement à l'ouverture</p>
                                                    </div>
                                                    <!--label class="relative inline-flex items-center cursor-pointer">
                                                        <input type="checkbox" v-model="autoOptions.enabled" class="sr-only peer">
                                                        <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                                                    </label-->


                                                    <label class="toggle-switch">
                                                        <input type="checkbox" v-model="autoOptions.enabled">
                                                        <span class="toggle-slider"></span>
                                                    </label>





                                                </div>

                                                <div v-if="autoOptions.enabled" class="grid grid-cols-1 md:grid-cols-3 gap-4 pl-4 border-l-2 border-blue-200">
                                                    <div class="space-y-2">
                                                        <label class="ti-form-label mb-0">Délai avant impression</label>
                                                        <select v-model.number="autoOptions.delay" class="form-control">
                                                            <option :value="0">Immédiat</option>
                                                            <option :value="300">300ms</option>
                                                            <option :value="500">500ms (recommandé)</option>
                                                            <option :value="1000">1 seconde</option>
                                                            <option :value="2000">2 secondes</option>
                                                        </select>
                                                    </div>

                                                    <div class="space-y-2">
                                                        <label class="flex items-center gap-2 cursor-pointer mt-6">
                                                            <input type="checkbox" v-model="autoOptions.showPreview" class="ti-form-checkbox">
                                                            <span class="text-sm">Afficher l'aperçu</span>
                                                        </label>
                                                    </div>

                                                    <div class="space-y-2">
                                                        <label class="flex items-center gap-2 cursor-pointer mt-6">
                                                            <input type="checkbox" v-model="autoOptions.closeAfter" class="ti-form-checkbox">
                                                            <span class="text-sm">Fermer après impression</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="space-y-4">
                                                <h6 class="font-semibold">Dimensions personnalisées</h6>
                                                <div class="flex items-center gap-2">
                                                    <input
                                                            v-model="customWidth"
                                                            type="number"
                                                            class="form-control w-24"
                                                            placeholder="Largeur"
                                                    >
                                                    <span>×</span>
                                                    <input
                                                            v-model="customHeight"
                                                            type="number"
                                                            class="form-control w-24"
                                                            placeholder="Hauteur"
                                                    >
                                                    <select v-model="customUnit" class="form-control w-20">
                                                        <option value="mm">mm</option>
                                                        <option value="cm">cm</option>
                                                        <option value="in">in</option>
                                                        <option value="px">px</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="space-y-4">
                                                <h6 class="font-semibold">Options d'impression</h6>
                                                <div class="space-y-2">
                                                    <label class="flex items-center gap-2 cursor-pointer">
                                                        <input type="checkbox" v-model="printOptions.cutAfterPrint" class="ti-form-checkbox">
                                                        <span class="text-sm">Couper après impression</span>
                                                    </label>
                                                    <label class="flex items-center gap-2 cursor-pointer">
                                                        <input type="checkbox" v-model="printOptions.openCashDrawer" class="ti-form-checkbox">
                                                        <span class="text-sm">Ouvrir tiroir-caisse</span>
                                                    </label>
                                                    <label class="flex items-center gap-2 cursor-pointer">
                                                        <input type="checkbox" v-model="printOptions.silentPrint" class="ti-form-checkbox">
                                                        <span class="text-sm">Impression silencieuse</span>
                                                    </label>
                                                </div>
                                            </div>

                                            <div class="md:col-span-2 space-y-4">
                                                <h6 class="font-semibold">Historique des configurations</h6>
                                                <div class="max-h-32 overflow-y-auto">
                                                    <div
                                                            v-for="(config, index) in printHistory.slice(0, 5)"
                                                            :key="index"
                                                            class="flex items-center justify-between p-2 border-b hover:bg-gray-100 cursor-pointer"
                                                            @click="applyHistoryConfig(config)"
                                                    >
                                                        <div class="text-sm">
                                                            <span class="font-medium">{{ getFormatName(config.selectedFormat) }}</span>
                                                            <span class="text-gray-500 ml-2">{{ config.fontSize }}px</span>
                                                            <span v-if="config.watermark?.enabled" class="ml-2 text-blue-500">
                                                                <i class="ri-drop-line"></i> {{ config.watermark.text }}
                                                            </span>
                                                            <span v-if="config.autoOptions?.enabled" class="ml-2 text-yellow-500">
                                                                <i class="ri-flashlight-line"></i> Auto
                                                            </span>
                                                        </div>
                                                        <span class="text-xs text-gray-400">{{ formatDate(config.timestamp) }}</span>
                                                    </div>
                                                    <p v-if="printHistory.length === 0" class="text-sm text-gray-500 text-center py-2">
                                                        Aucun historique
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </transition>

                            <!-- Boutons d'action (toujours visibles) -->
                            <div class="flex flex-wrap gap-2 my-4">
                                <button @click="printTicket()" class="ti-btn ti-btn-success-full">
                                    <i class="ri-printer-line mr-2"></i> Imprimer
                                </button>
                                <button @click="previewFullScreen" class="ti-btn ti-btn-primary-full">
                                    <i class="ri-fullscreen-line mr-2"></i> Plein écran
                                </button>
                                <button @click="copyToClipboard" class="ti-btn ti-btn-light">
                                    <i class="ri-file-copy-line mr-2"></i> Copier
                                </button>

                                <!-- Indicateurs de configuration actuelle -->
                                <div class="flex items-center gap-2 ml-auto text-sm text-gray-500">
                                    <span class="badge bg-gray-200 text-gray-700">{{ getSelectedFormat.name }}</span>
                                    <span class="badge bg-gray-200 text-gray-700">{{ fontSize }}px</span>
                                    <span v-if="watermark.enabled" class="badge bg-blue-100 text-blue-700">
                                        <i class="ri-drop-line mr-1"></i>{{ watermark.text }}
                                    </span>
                                </div>
                            </div>

                            <!-- Zone d'aperçu -->
                            <div class="border rounded-lg p-4 bg-white">
                                <div class="flex justify-between items-center mb-4">
                                    <h4 class="text-lg font-semibold">
                                        <i class="ri-eye-line mr-2"></i>Aperçu
                                    </h4>

                                    <!-- Contrôles de zoom -->
                                    <div class="preview-controls flex items-center gap-2">
                                        <button @click="previewZoom = Math.max(50, previewZoom - 10)" class="ti-btn ti-btn-light ti-btn-xs">
                                            <i class="ri-zoom-out-line"></i>
                                        </button>
                                        <span class="text-sm w-12 text-center">{{ previewZoom }}%</span>
                                        <button @click="previewZoom = Math.min(200, previewZoom + 10)" class="ti-btn ti-btn-light ti-btn-xs">
                                            <i class="ri-zoom-in-line"></i>
                                        </button>
                                        <button @click="previewZoom = 100" class="ti-btn ti-btn-light ti-btn-xs">
                                            <i class="ri-refresh-line"></i>
                                        </button>
                                    </div>
                                </div>

                                <!-- Container d'aperçu -->
                                <div
                                        class="overflow-auto border rounded bg-gray-100 p-4"
                                        :style="previewContainerStyle"
                                >
                                    <div
                                            ref="printorderdatadeux"
                                            class="print-content"
                                            :style="printContentStyle"
                                    >
                                        <div
                                                v-for="(copy, index) in Array(copiesPerPage).fill()"
                                                :key="index"
                                                class="ticket-copy"
                                                :class="{ 'page-break': index > 0 && !isSamePage(index) }"
                                                :style="copyContainerStyle"
                                        >
                                            <!-- Template de ticket avec filigrane -->
                                            <div class="ticket" :style="ticketStyle">
                                                <!-- FILIGRANE (arrière-plan) -->
                                                <div
                                                        v-if="watermark.enabled && watermark.text"
                                                        class="watermark-container"
                                                        :class="'watermark-' + watermark.position"
                                                        :style="watermarkContainerStyle"
                                                >
                                                    <template v-if="watermark.repeat === 'single'">
                                                        <span class="watermark-text" :style="watermarkStyle">
                                                            {{ watermark.text }}
                                                        </span>
                                                    </template>
                                                    <template v-else>
                                                        <div class="watermark-pattern" :style="watermarkPatternStyle">
                                                            <span
                                                                    v-for="i in 9"
                                                                    :key="i"
                                                                    class="watermark-text"
                                                                    :style="watermarkStyle"
                                                            >
                                                                {{ watermark.text }}
                                                            </span>
                                                        </div>
                                                    </template>
                                                </div>

                                                <!-- Contenu du ticket (au-dessus du filigrane) -->
                                                <div class="ticket-content" style="position: relative; z-index: 1;">
                                                    <!-- En-tête avec logo -->
                                                    <div v-if="options.showLogo && $store.state.etatlogo" class="ticket-header text-center mb-2">
                                                        <img
                                                                :src="$store.state.etatlogo"
                                                                :style="logoStyleComputed"
                                                                alt="Logo"
                                                                class="logo-img"
                                                        >
                                                    </div>

                                                    <!-- Informations magasin -->
                                                    <div v-if="options.showStoreInfo" class="store-info text-center mb-3">
                                                        <h2
                                                                v-if="$store.state.etatraisonsocial"
                                                                class="store-name font-bold"
                                                                :style="{ fontSize: `${parseInt(fontSize) + 4}px` }"
                                                        >
                                                            {{ $store.state.etatraisonsocial }}
                                                        </h2>
                                                        <p
                                                                v-if="$store.state.etatifu || $store.state.etatrccm"
                                                                class="store-legal"
                                                                :style="{ fontSize: `${fontSize}px` }"
                                                        >
                                                            <template v-if="$store.state.etatifu">IFU: {{ $store.state.etatifu }}</template>
                                                            <template v-if="$store.state.etatrccm"> | RCCM: {{ $store.state.etatrccm }}</template>
                                                        </p>
                                                        <p
                                                                v-if="$store.state.etatadresse"
                                                                class="store-address"
                                                                :style="{ fontSize: `${fontSize}px` }"
                                                        >
                                                            {{ $store.state.etatadresse }}
                                                        </p>
                                                        <p
                                                                v-if="$store.state.etattelephone"
                                                                class="store-phone"
                                                                :style="{ fontSize: `${fontSize}px` }"
                                                        >
                                                            Tél: {{ $store.state.etattelephone }}
                                                        </p>
                                                    </div>

                                                    <div class="divider"></div>

                                                    <!-- Type de document -->
                                                    <div v-if="options.showDocType" class="doc-type text-center mb-2">
                                                        <span
                                                                class="doc-type-badge font-bold uppercase"
                                                                :style="{ fontSize: `${parseInt(fontSize) + 2}px` }"
                                                        >
                                                            {{ typeimpression === 'note' ? '*** NOTE ***' : '*** FACTURE ***' }}
                                                        </span>
                                                    </div>

                                                    <!-- Informations de la transaction -->
                                                    <div class="transaction-info mb-3" :style="{ fontSize: `${fontSize}px` }">
                                                        <p class="print-datetime text-center font-medium">
                                                            <span>Imprimé le:</span> {{ currentDateTime() }}
                                                        </p>
                                                        <div class="divider-light"></div>
                                                        <p><span class="label">Date:</span> {{ tabvalue.date }}</p>
                                                        <p>
                                                            <span class="label">Client:</span> {{ tabvalue.client }}
                                                            <template v-if="tabvalue.ifu"> - IFU: {{ tabvalue.ifu }}</template>
                                                        </p>
                                                        <p>
                                                            <span v-if="typeimpression !== 'note'" class="label">Facture:</span>
                                                            <span v-else class="label">Note:</span>
                                                            {{ tabvalue.numdoc }}
                                                        </p>
                                                        <p>
                                                            <span class="label">Caisse:</span> {{ tabvalue.docsaisiepar }}
                                                            <template v-if="tabvalue.serveur"> - Serveur: {{ tabvalue.serveur }}</template>
                                                            <template v-if="tabvalue.commandetable"> - Table: {{ tabvalue.commandetable }}</template>
                                                        </p>
                                                    </div>

                                                    <div class="divider"></div>

                                                    <!-- Table des articles -->
                                                    <table
                                                            class="items-table w-full mb-4"
                                                            :style="{ fontSize: `${fontSize}px` }"
                                                            :class="{ 'table-compact': density === 'compact', 'table-comfortable': density === 'comfortable' }"
                                                    >
                                                        <thead>
                                                        <tr>
                                                            <th v-if="options.showItemNumber" class="col-num">N°</th>
                                                            <th class="col-designation">Désignation</th>
                                                            <th class="col-qty">Qté</th>
                                                            <th v-if="options.showUnitPrice" class="col-price">P.U</th>
                                                            <th class="col-total">Total</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-for="(item, idx) in tabvalue.items" :key="idx">
                                                            <td v-if="options.showItemNumber" class="text-center">{{ idx + 1 }}</td>
                                                            <td class="col-designation">
                                                                <template v-if="item.autredesignation === ''">
                                                                    {{ item.article.libelle }}
                                                                    <span v-if="options.showTaxInfo" class="tax-info">({{ item.article.taxedimposition }})</span>
                                                                </template>
                                                                <template v-else>
                                                                    {{ item.article.libelle }}
                                                                    <span class="variant-info">({{ item.autredesignation }})</span>
                                                                    <span v-if="options.showTaxInfo" class="tax-info">({{ item.article.taxedimposition }})</span>
                                                                </template>
                                                            </td>
                                                            <td class="text-center">{{ formatNumber(item.qtite) }}</td>
                                                            <td v-if="options.showUnitPrice" class="text-right">{{ formatNumber(item.pu) }}</td>
                                                            <td class="text-right">{{ calculSomme(item.mtnt, item.remise, 0) }}</td>
                                                        </tr>
                                                        </tbody>
                                                        <tfoot>
                                                        <tr class="total-row">
                                                            <td :colspan="getColspan" class="text-right label">
                                                                Montant Total
                                                            </td>
                                                            <td class="text-right value">{{ tabvalue.montantht }}</td>
                                                        </tr>
                                                        <tr v-if="parseFloat(tabvalue.montantremise) > 0" class="discount-row">
                                                            <td :colspan="getColspan" class="text-right label">
                                                                Remise
                                                            </td>
                                                            <td class="text-right value discount">-{{ tabvalue.montantremise }}</td>
                                                        </tr>
                                                        <tr class="net-row">
                                                            <td :colspan="getColspan" class="text-right label font-bold">
                                                                Net à payer
                                                            </td>
                                                            <td class="text-right value font-bold">{{ tabvalue.montantnetapayer }}</td>
                                                        </tr>

                                                        <template v-if="typeimpression !== 'note'">
                                                            <tr class="payment-row">
                                                                <td :colspan="getColspan" class="text-right label">
                                                                    Montant reçu
                                                                </td>
                                                                <td class="text-right value">{{ tabvalue.reglement }}</td>
                                                            </tr>
                                                            <tr v-if="tabvalue.montantmonnaie !== 0" class="change-row">
                                                                <td :colspan="getColspan" class="text-right label">
                                                                    {{ parseFloat(tabvalue.montantmonnaie) > 0 ? 'Monnaie rendue' : 'Reste dû' }}
                                                                </td>
                                                                <td class="text-right value">{{ tabvalue.montantmonnaie }}</td>
                                                            </tr>
                                                        </template>
                                                        </tfoot>
                                                    </table>

                                                    <!-- Montant en lettres -->
                                                    <div v-if="options.showAmountInWords" class="amount-words mb-3" :style="{ fontSize: `${parseInt(fontSize) - 1}px` }">
                                                        <p class="italic">
                                                            <span class="label">Arrêté à:</span> {{ numbertolettre(tabvalue.montantnetapayer) }} francs CFA
                                                        </p>
                                                    </div>

                                                    <!-- Message pour les notes -->
                                                    <template v-if="typeimpression === 'note'">
                                                        <div class="divider"></div>
                                                        <div class="note-warning text-center" :style="{ fontSize: `${fontSize}px` }">
                                                            <p class="font-bold text-warning">
                                                                ⚠️ ATTENTION: Ce document n'est pas une facture.<br>
                                                                Veuillez demander votre facture !
                                                            </p>
                                                        </div>
                                                    </template>

                                                    <!-- QR Code et MECeF -->
                                                    <template v-if="parseFloat(tabvalue.normalise) > 0 && options.showQRCode">
                                                        <div class="divider"></div>
                                                        <div class="mecef-section flex items-center justify-between gap-2">
                                                            <div class="qrcode-container">
                                                                <img
                                                                        :src="qrCodeImage"
                                                                        :width="qrCodeSize"
                                                                        :height="qrCodeSize"
                                                                        alt="QR Code"
                                                                        class="qrcode-img"
                                                                >
                                                            </div>
                                                            <div class="mecef-info text-right" :style="{ fontSize: `${parseInt(fontSize) - 1}px` }">
                                                                <p><span class="label">MECeF:</span> {{ tabvalue.mecefsignature }}</p>
                                                                <p><span class="label">NIM:</span> {{ tabvalue.mecefnim }}</p>
                                                                <p><span class="label">Compteur:</span> {{ tabvalue.mecefcompteur }}</p>
                                                                <p><span class="label">Heure:</span> {{ tabvalue.mecefheure }}</p>
                                                                <p class="conformity">✓ Conforme DGI Bénin</p>
                                                            </div>
                                                        </div>
                                                    </template>

                                                    <!-- Pied de page -->
                                                    <template v-if="options.showFooter">
                                                        <div class="divider"></div>
                                                        <div class="ticket-footer text-center" :style="{ fontSize: `${parseInt(fontSize) - 1}px` }">
                                                            <p class="thank-you">{{ customFooterText || 'Merci de votre visite !' }}</p>
                                                            <p v-if="options.showPoweredBy" class="powered-by">
                                                                *** HSIGCOM - Tél: 01-43-92-70-13 / 01-97-40-87-08 ***
                                                            </p>
                                                        </div>
                                                    </template>

                                                    <!-- Talon serveuse (à déchirer) -->
                                                    <template v-if="options.showServerSlip">
                                                        <div class="slip-spacer"></div>
                                                        <div class="server-slip-cutline" :style="{ fontSize: `${parseInt(fontSize) - 1}px` }">
                                                            - - - - ✂ DÉCOUPER ICI ✂ - - - -
                                                        </div>
                                                        <div class="server-slip" :style="{ fontSize: `${fontSize}px` }">
                                                            <div class="server-slip-header">
                                                                <span class="server-slip-title">▪ TALON SERVEUSE ▪</span>
                                                            </div>
                                                            <table class="server-slip-table">
                                                                <tr>
                                                                    <td class="slip-label">Date</td>
                                                                    <td class="slip-dots"></td>
                                                                    <td class="slip-value">{{ tabvalue.date }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="slip-label">Note N°</td>
                                                                    <td class="slip-dots"></td>
                                                                    <td class="slip-value">{{ tabvalue.numdoc }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="slip-label">Caisse</td>
                                                                    <td class="slip-dots"></td>
                                                                    <td class="slip-value">{{ tabvalue.docsaisiepar }}</td>
                                                                </tr>
                                                                <tr v-if="tabvalue.commandetable">
                                                                    <td class="slip-label">Table</td>
                                                                    <td class="slip-dots"></td>
                                                                    <td class="slip-value">{{ tabvalue.commandetable }}</td>
                                                                </tr>
                                                                <tr v-if="tabvalue.serveur">
                                                                    <td class="slip-label">Serveur</td>
                                                                    <td class="slip-dots"></td>
                                                                    <td class="slip-value">{{ tabvalue.serveur }}</td>
                                                                </tr>
                                                            </table>
                                                            <div class="slip-amount-separator">- - - - - - - - - - - - - - - - - - - -</div>
                                                            <div class="slip-amount-row" :style="{ fontSize: `${parseInt(fontSize) + 1}px` }">
                                                                <span class="slip-amount-label">NET À PAYER</span>
                                                                <span class="slip-amount-value">{{ tabvalue.montantnetapayer }} FCFA</span>
                                                            </div>
                                                            <div class="slip-amount-separator">- - - - - - - - - - - - - - - - - - - -</div>
                                                        </div>
                                                    </template>
                                                </div>

                                                <!-- Séparateur entre copies -->
                                                <div v-if="index < copiesPerPage - 1 && copiesPerPage > 1" class="copy-separator">
                                                    <div class="cut-line">✂ - - - - - - - - - - - - - - - - - - - - - -</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Footer -->
                <div class="cf-dialog-foot">
                    <button @click="printTicket()" type="button" class="ti-btn ti-btn-primary-full"><i class="ri-printer-line align-middle"></i> Imprimer</button>
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                </div>

          </div>
        </Transition>
      </div>
    </Transition>

    <!-- Modal plein écran -->
    <div v-if="showFullScreenPreview" class="fixed inset-0 z-[100] bg-white overflow-auto">
        <div class="sticky top-0 bg-white border-b p-4 flex justify-between items-center">
            <h4 class="text-lg font-semibold">Aperçu plein écran</h4>
            <button @click="showFullScreenPreview = false" class="ti-btn ti-btn-danger-full">
                <i class="ri-close-line mr-2"></i> Fermer
            </button>
        </div>
        <div class="p-8 flex justify-center">
            <div v-html="fullScreenContent" :style="{ transform: `scale(${previewZoom / 100})`, transformOrigin: 'top center' }"></div>
        </div>
    </div>
</template>

<script>
    import {
        currencyFormatMonney,
        currentDate,
        currentDateTime,
        ExportExcel,
        FormatNumber,
        getYear,
        impression,
        NumbertoLettre
    } from "@/allfunction";
    import { tryOpenDrawer } from "@/service/cashdrawer";

    var STORAGE_KEY = '';
    var HISTORY_KEY = '';

    export default {
        /* eslint-disable */
        name: "TicketPrintProV2",

        props: {
            // Permet de déclencher l'impression automatique à l'ouverture
            autoPrint: {
                type: Boolean,
                default: false
            },
            // Délai avant l'impression automatique (en ms)
            autoPrintDelay: {
                type: Number,
                default: 500
            },
            // Fermer automatiquement après impression
            closeAfterPrint: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                // Toggle pour afficher/masquer les paramètres
                showSettings: false,

                // Options d'impression automatique (peuvent être modifiées via l'interface)
                autoOptions: {
                    autoPrint: false,
                    enabled: false,
                    delay: 500,
                    closeAfter: false,
                    showPreview: true // Si false, imprime directement sans afficher le modal
                },

                // Onglets de configuration (avec nouvel onglet filigrane)
                activeTab: 'format',
                configTabs: [
                    { id: 'format', name: 'Format', icon: 'ri-layout-line' },
                    { id: 'style', name: 'Style', icon: 'ri-font-size' },
                    { id: 'content', name: 'Contenu', icon: 'ri-file-list-line' },
                    { id: 'colors', name: 'Couleurs', icon: 'ri-palette-line' },
                    { id: 'watermark', name: 'Filigrane', icon: 'ri-drop-line' },
                    { id: 'advanced', name: 'Avancé', icon: 'ri-settings-line' }
                ],

                // Configuration du filigrane
                watermark: {
                    enabled: false,
                    text: 'PAYÉ',
                    fontSize: 60,
                    opacity: 15,
                    rotation: -30,
                    color: '#000000',
                    position: 'center', // 'top', 'center', 'bottom'
                    repeat: 'single' // 'single', 'repeat'
                },

                // Textes prédéfinis pour le filigrane
                watermarkPresets: ['PAYÉ', 'NOTE', 'COPIE', 'ANNULÉ', 'DUPLICATA', 'ORIGINAL', 'CONFIDENTIEL', 'BROUILLON', 'PERSONNALISER'],

                colors: {
                    storeName: '#111827',
                    storeInfo: '#374151',
                    docType: '#111827',
                    /*labelText: '#6b7280',*/
                    labelText: '#000000',
                    valueText: '#111827',
                    tableHeaderBg: '#f3f4f6',
                    tableHeaderText: '#111827',
                    tableBodyText: '#111827',
                    totalBg: '#f9fafb',
                    netBg: '#e5e7eb',
                    netText: '#111827',
                    footerText: '#6b7280',
                    dividerColor: '#9ca3af',
                    ticketBg: '#ffffff',
                    borderColor: '#e5e7eb',
                },

                colorPresets: [
                    { name: 'Classique', icon: '⬜', colors: { storeName: '#111827', storeInfo: '#374151', docType: '#111827', labelText: '#6b7280', valueText: '#111827', tableHeaderBg: '#f3f4f6', tableHeaderText: '#111827', tableBodyText: '#111827', totalBg: '#f9fafb', netBg: '#e5e7eb', netText: '#111827', footerText: '#6b7280', dividerColor: '#9ca3af', ticketBg: '#ffffff', borderColor: '#e5e7eb' } },
                    { name: 'Bleu', icon: '🔵', colors: { storeName: '#1e40af', storeInfo: '#1d4ed8', docType: '#1e3a8a', labelText: '#3b82f6', valueText: '#1e40af', tableHeaderBg: '#dbeafe', tableHeaderText: '#1e40af', tableBodyText: '#1f2937', totalBg: '#eff6ff', netBg: '#bfdbfe', netText: '#1e3a8a', footerText: '#6b7280', dividerColor: '#93c5fd', ticketBg: '#ffffff', borderColor: '#bfdbfe' } },
                    { name: 'Vert', icon: '🟢', colors: { storeName: '#065f46', storeInfo: '#047857', docType: '#064e3b', labelText: '#059669', valueText: '#065f46', tableHeaderBg: '#d1fae5', tableHeaderText: '#065f46', tableBodyText: '#1f2937', totalBg: '#ecfdf5', netBg: '#a7f3d0', netText: '#064e3b', footerText: '#6b7280', dividerColor: '#6ee7b7', ticketBg: '#ffffff', borderColor: '#a7f3d0' } },
                    { name: 'Rouge', icon: '🔴', colors: { storeName: '#991b1b', storeInfo: '#b91c1c', docType: '#7f1d1d', labelText: '#ef4444', valueText: '#991b1b', tableHeaderBg: '#fee2e2', tableHeaderText: '#991b1b', tableBodyText: '#1f2937', totalBg: '#fff1f2', netBg: '#fecaca', netText: '#7f1d1d', footerText: '#6b7280', dividerColor: '#fca5a5', ticketBg: '#ffffff', borderColor: '#fecaca' } },
                    { name: 'Sombre', icon: '⬛', colors: { storeName: '#f9fafb', storeInfo: '#d1d5db', docType: '#f3f4f6', labelText: '#9ca3af', valueText: '#e5e7eb', tableHeaderBg: '#374151', tableHeaderText: '#f9fafb', tableBodyText: '#e5e7eb', totalBg: '#1f2937', netBg: '#111827', netText: '#f9fafb', footerText: '#9ca3af', dividerColor: '#4b5563', ticketBg: '#1f2937', borderColor: '#374151' } },
                ],

                // Catégories de formats
                formatCategories: [
                    { id: 'pos', name: 'Imprimantes POS/Thermiques' },
                    { id: 'paper', name: 'Papier standard' },
                    { id: 'custom', name: 'Personnalisé' }
                ],
                selectedCategory: 'pos',

                // Tous les formats d'impression POS
                printFormats: [
                    { id: 'pos-32mm', name: '32mm (Mobile)', width: '32mm', widthPx: 120, type: 'pos', category: 'pos', dpi: 203 },
                    { id: 'pos-40mm', name: '40mm', width: '40mm', widthPx: 150, type: 'pos', category: 'pos', dpi: 203 },
                    { id: 'pos-48mm', name: '48mm', width: '48mm', widthPx: 180, type: 'pos', category: 'pos', dpi: 203 },
                    { id: 'pos-57mm', name: '57mm (Standard)', width: '57mm', widthPx: 215, type: 'pos', category: 'pos', dpi: 203 },
                    { id: 'pos-58mm', name: '58mm', width: '58mm', widthPx: 219, type: 'pos', category: 'pos', dpi: 203 },
                    { id: 'pos-76mm', name: '76mm (Kitchen)', width: '76mm', widthPx: 287, type: 'pos', category: 'pos', dpi: 203 },
                    { id: 'pos-80mm', name: '80mm (Standard)', width: '80mm', widthPx: 302, type: 'pos', category: 'pos', dpi: 203 },
                    { id: 'pos-82mm', name: '82.5mm', width: '82.5mm', widthPx: 311, type: 'pos', category: 'pos', dpi: 203 },
                    { id: 'pos-110mm', name: '110mm (Large)', width: '110mm', widthPx: 415, type: 'pos', category: 'pos', dpi: 203 },
                    { id: 'pos-112mm', name: '112mm', width: '112mm', widthPx: 423, type: 'pos', category: 'pos', dpi: 203 },
                    { id: 'a4-portrait', name: 'A4 Portrait', width: '210mm', height: '297mm', type: 'paper', category: 'paper' },
                    { id: 'a4-landscape', name: 'A4 Paysage', width: '297mm', height: '210mm', type: 'paper', category: 'paper' },
                    { id: 'a5-portrait', name: 'A5 Portrait', width: '148mm', height: '210mm', type: 'paper', category: 'paper' },
                    { id: 'a5-landscape', name: 'A5 Paysage', width: '210mm', height: '148mm', type: 'paper', category: 'paper' },
                    { id: 'a6-portrait', name: 'A6 Portrait', width: '105mm', height: '148mm', type: 'paper', category: 'paper' },
                    { id: 'letter-portrait', name: 'Letter Portrait', width: '216mm', height: '279mm', type: 'paper', category: 'paper' },
                    { id: 'letter-landscape', name: 'Letter Paysage', width: '279mm', height: '216mm', type: 'paper', category: 'paper' },
                    { id: 'custom', name: 'Personnalisé', width: 'auto', type: 'custom', category: 'custom' }
                ],

                selectedFormat: 'pos-80mm',
                orientation: 'portrait',
                fontSize: 10,
                fontFamily: "'Courier New', monospace",
                fontWeight: '400',
                lineHeight: 1.3,
                margins: 5,
                density: 'normal',
                copiesPerPage: 1,

                customWidth: 80,
                customHeight: null,
                customUnit: 'mm',

                availableFonts: [
                    { name: 'Courier New (Monospace)', value: "'Courier New', monospace" },
                    { name: 'Consolas', value: "'Consolas', monospace" },
                    { name: 'Monaco', value: "'Monaco', monospace" },
                    { name: 'Lucida Console', value: "'Lucida Console', monospace" },
                    { name: 'Arial', value: "'Arial', sans-serif" },
                    { name: 'Helvetica', value: "'Helvetica', sans-serif" },
                    { name: 'Verdana', value: "'Verdana', sans-serif" },
                    { name: 'Tahoma', value: "'Tahoma', sans-serif" },
                    { name: 'Times New Roman', value: "'Times New Roman', serif" },
                    { name: 'Georgia', value: "'Georgia', serif" }
                ],

                options: {
                    showLogo: true,
                    showQRCode: true,
                    showStoreInfo: true,
                    showFooter: true,
                    showDocType: true,
                    showItemNumber: true,
                    showUnitPrice: true,
                    showTaxInfo: true,
                    showAmountInWords: true,
                    showPoweredBy: true,
                    showBorder: true,
                    showServerSlip: false
                },

                contentOptions: [
                    { key: 'showLogo', label: 'Logo',disabled:true },
                    { key: 'showStoreInfo', label: 'Infos magasin',disabled:true },
                    { key: 'showDocType', label: 'Type de document',disabled:true },
                    { key: 'showItemNumber', label: 'N° article',disabled:false },
                    { key: 'showUnitPrice', label: 'Prix unitaire',disabled:false },
                    { key: 'showTaxInfo', label: 'Info taxe',disabled:true },
                    { key: 'showQRCode', label: 'QR Code MECeF',disabled:true },
                    { key: 'showAmountInWords', label: 'Montant en lettres',disabled:true },
                    { key: 'showFooter', label: 'Pied de page',disabled:true },
                    { key: 'showPoweredBy', label: 'Mention HSIGCOM',disabled:true },
                    { key: 'showBorder', label: 'Bordure',disabled:false },
                    { key: 'showServerSlip', label: 'Talon serveuse',disabled:false }
                ],

                printOptions: {
                    cutAfterPrint: true,
                    openCashDrawer: false,
                    silentPrint: false
                },

                logoSize: {
                    width: 80,
                    height: 70
                },

                qrCodeSize: 60,
                customFooterText: '',
                previewZoom: 100,
                showFullScreenPreview: false,
                fullScreenContent: '',
                printHistory: [],

                isdisplay: false,
                titlemodal: "",
                tabvalue: {},
                typeimpression: "",
                mgetyear: getYear(),
                datenow: currentDate(),


                searchword: "",
                searchtrierletableau: "",
                posts: [''],
                page: 1,
                perPage: 1,
                Defaultpage: 1,
                DefaultperPage: 1,
                pages: [],






            };
        },

        computed: {
            filteredFormats() {
                return this.printFormats.filter(f => f.category === this.selectedCategory);
            },

            getSelectedFormat() {
                return this.printFormats.find(f => f.id === this.selectedFormat) || this.printFormats[0];
            },

            showOrientationOption() {
                const format = this.getSelectedFormat;
                return format.type === 'paper';
            },

            availableCopies() {
                const format = this.getSelectedFormat;
                if (format.type === 'pos') {
                    return [1, 2, 3];
                } else if (format.type === 'paper') {
                    return this.orientation === 'landscape' ? [1, 2, 4] : [1, 2, 3];
                }
                return [1, 2, 3, 4];
            },

            fontSizeRange() {
                const format = this.getSelectedFormat;
                if (format.type === 'pos') {
                    if (format.widthPx && format.widthPx < 200) {
                        return { min: 6, max: 12 };
                    }
                    return { min: 7, max: 14 };
                }
                return { min: 8, max: 18 };
            },

            getColspan() {
                return this.options.showUnitPrice && this.options.showItemNumber ? 4 :
                    (this.options.showItemNumber || this.options.showUnitPrice ? 3 : 2);
            },

            previewContainerStyle() {
                const format = this.getSelectedFormat;
                let maxWidth = '100%';
                let maxHeight = '500px';

                if (format.type === 'pos') {
                    maxWidth = `${Math.min(400, (format.widthPx || 300) + 40)}px`;
                    maxHeight = '600px';
                } else if (format.type === 'paper') {
                    maxWidth = this.orientation === 'landscape' ? '800px' : '600px';
                    maxHeight = '700px';
                }

                return {
                    maxWidth,
                    maxHeight,
                    margin: '0 auto',
                    backgroundColor: '#f3f4f6'
                };
            },

            printContentStyle() {
                return {
                    fontSize: `${this.fontSize}px`,
                    fontFamily: this.fontFamily,
                    fontWeight: this.fontWeight,
                    lineHeight: this.lineHeight,
                    transform: `scale(${this.previewZoom / 100})`,
                    transformOrigin: 'top center'
                };
            },

            copyContainerStyle() {
                if (this.copiesPerPage > 1) {
                    const perRow = this.copiesPerPage <= 2 ? 2 : 2;
                    return {
                        display: 'inline-block',
                        width: `${100 / perRow}%`,
                        verticalAlign: 'top',
                        padding: '5px',
                        boxSizing: 'border-box'
                    };
                }
                return {};
            },

            ticketStyle() {
                const format = this.getSelectedFormat;
                let width, margin, padding;

                if (format.type === 'pos') {
                    width = format.id === 'custom'
                        ? `${this.customWidth}${this.customUnit}`
                        : format.width;
                    margin = '0 auto';
                    padding = this.density === 'compact' ? '3px' : (this.density === 'comfortable' ? '12px' : '8px');
                } else if (format.type === 'paper') {
                    width = this.copiesPerPage > 1 ? '95%' : '100%';
                    margin = '0 auto';
                    padding = `${this.margins}mm`;
                } else {
                    width = `${this.customWidth}${this.customUnit}`;
                    margin = '0 auto';
                    padding = '8px';
                }

                return {
                    width,
                    margin,
                    padding,
                    background: this.colors.ticketBg,
                    boxShadow: this.options.showBorder ? '0 2px 8px rgba(0,0,0,0.1)' : 'none',
                    border: this.options.showBorder ? `1px solid ${this.colors.borderColor}` : 'none',
                    pageBreakInside: 'avoid',
                    position: 'relative',
                    overflow: 'hidden',
                    '--c-store-name': this.colors.storeName,
                    '--c-store-info': this.colors.storeInfo,
                    '--c-doc-type': this.colors.docType,
                    '--c-label': this.colors.labelText,
                    '--c-value': this.colors.valueText,
                    '--c-th-bg': this.colors.tableHeaderBg,
                    '--c-th-text': this.colors.tableHeaderText,
                    '--c-td': this.colors.tableBodyText,
                    '--c-total-bg': this.colors.totalBg,
                    '--c-net-bg': this.colors.netBg,
                    '--c-net-text': this.colors.netText,
                    '--c-footer': this.colors.footerText,
                    '--c-divider': this.colors.dividerColor,
                };
            },

            logoStyleComputed() {
                return {
                    display: 'block',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    width: `${this.logoSize.width}px`,
                    height: `${this.logoSize.height}px`,
                    maxWidth: '100%',
                    objectFit: 'contain'
                };
            },

            qrCodeImage() {
                return this.tabvalue.mecefqrr || '';
            },

            // Styles pour le filigrane
            watermarkContainerStyle() {
                return {
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    display: 'flex',
                    alignItems: this.watermark.position === 'top' ? 'flex-start' :
                        (this.watermark.position === 'bottom' ? 'flex-end' : 'center'),
                    justifyContent: 'center',
                    pointerEvents: 'none',
                    zIndex: 0,
                    overflow: 'hidden',
                    padding: this.watermark.position === 'top' ? '20px 0 0 0' :
                        (this.watermark.position === 'bottom' ? '0 0 20px 0' : '0')
                };
            },

            watermarkStyle() {
                const opacity = this.watermark.opacity / 100;
                return {
                    fontSize: `${this.watermark.fontSize}px`,
                    fontWeight: '700',
                    color: this.watermark.color,
                    opacity: opacity,
                    transform: `rotate(${this.watermark.rotation}deg)`,
                    textTransform: 'uppercase',
                    letterSpacing: '4px',
                    whiteSpace: 'nowrap',
                    userSelect: 'none',
                    fontFamily: 'Arial, sans-serif'
                };
            },

            watermarkPatternStyle() {
                return {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    gridTemplateRows: 'repeat(3, 1fr)',
                    gap: '20px',
                    width: '200%',
                    height: '200%',
                    alignItems: 'center',
                    justifyItems: 'center'
                };
            },

            watermarkPreviewStyle() {
                const opacity = this.watermark.opacity / 100;
                return {
                    fontSize: `${Math.min(this.watermark.fontSize, 40)}px`,
                    fontWeight: '700',
                    color: this.watermark.color,
                    opacity: opacity,
                    transform: `rotate(${this.watermark.rotation}deg)`,
                    textTransform: 'uppercase',
                    letterSpacing: '2px',
                    whiteSpace: 'nowrap'
                };
            },

            currentConfig() {
                return {
                    showSettings: this.showSettings,
                    selectedCategory: this.selectedCategory,
                    selectedFormat: this.selectedFormat,
                    orientation: this.orientation,
                    fontSize: this.fontSize,
                    fontFamily: this.fontFamily,
                    fontWeight: this.fontWeight,
                    lineHeight: this.lineHeight,
                    margins: this.margins,
                    density: this.density,
                    copiesPerPage: this.copiesPerPage,
                    customWidth: this.customWidth,
                    customHeight: this.customHeight,
                    customUnit: this.customUnit,
                    options: { ...this.options },
                    printOptions: { ...this.printOptions },
                    logoSize: { ...this.logoSize },
                    qrCodeSize: this.qrCodeSize,
                    customFooterText: this.customFooterText,
                    watermark: { ...this.watermark },
                    autoOptions: { ...this.autoOptions },
                    colors: { ...this.colors },
                    timestamp: new Date().toISOString()
                };
            },


        },

        watch: {
            selectedFormat: {
                handler(newFormat) {
                    this.adjustFontSizeForFormat();
                }
            }
        },

        mounted() {
           /* this.loadConfig();
            this.loadHistory();*/
        },

        methods: {

            handleOptionChange(opt, event) {
                // Bloquer si l'option est désactivée
                if (opt.disabled) {
                    event.target.checked = this.options[opt.key]; // Remettre l'ancienne valeur
                    return;
                }

                this.options[opt.key] = event.target.checked;
            },


            calculSomme(p1, p2, p3) {
                const number = Number(p1) + Number(p2) + Number(p3);
                return this.formatNumber(number);
            },

            formatNumber(p1) {
                return FormatNumber(Number(p1));
            },

            formatMonney(value) {
                return currencyFormatMonney(value);
            },

            numbertolettre(chiffre) { 
                return NumbertoLettre(chiffre);
            },

            currentDateTime() {
                return currentDateTime();
            },

            formatDate(dateString) {
                if (!dateString) return '';
                const date = new Date(dateString);
                return date.toLocaleDateString('fr-FR', {
                    day: '2-digit',
                    month: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit'
                });
            },

            returnFloatconvert(value) {
                return parseFloat(value).toFixed(4);
            },

            getFormatName(formatId) {
                const format = this.printFormats.find(f => f.id === formatId);
                return format ? format.name : formatId;
            },

            increaseFontSize() {
                if (this.fontSize < this.fontSizeRange.max) {
                    this.fontSize++;
                }
            },

            decreaseFontSize() {
                if (this.fontSize > this.fontSizeRange.min) {
                    this.fontSize--;
                }
            },

            adjustFontSizeForFormat() {
                const format = this.getSelectedFormat;
                if (format.type === 'pos') {
                    if (format.widthPx) {
                        if (format.widthPx <= 150) {
                            this.fontSize = Math.min(this.fontSize, 8);
                        } else if (format.widthPx <= 220) {
                            this.fontSize = Math.min(this.fontSize, 10);
                        }
                    }
                }
            },

            onCategoryChange() {
                const formats = this.filteredFormats;
                if (formats.length > 0) {
                    this.selectedFormat = formats[0].id;
                    this.updateFormatSettings();
                }
            },

            updateFormatSettings() {
                const format = this.getSelectedFormat;

                if (format.type === 'pos') {
                    this.density = 'compact';
                    this.margins = 3;
                    this.adjustFontSizeForFormat();
                } else if (format.type === 'paper') {
                    this.density = 'normal';
                    this.margins = 10;
                }

                if (!this.availableCopies.includes(this.copiesPerPage)) {
                    this.copiesPerPage = 1;
                }
            },

            isSamePage(index) {
                const format = this.getSelectedFormat;
                if (format.type === 'pos') return true;
                return index < this.copiesPerPage;
            },

            saveConfig() {
                try {
                    //STORAGE_KEY=STORAGE_KEY+"_"+this.typeimpression
                    localStorage.setItem(STORAGE_KEY, JSON.stringify(this.currentConfig));
                } catch (e) {
                    console.error('Erreur lors de la sauvegarde de la configuration:', e);
                }
            },

            loadConfig() {
                try {

                   // STORAGE_KEY=STORAGE_KEY+"_"+this.typeimpression

                    const saved = localStorage.getItem(STORAGE_KEY);
                    if (saved) {
                        let config = JSON.parse(saved);

                        config.autoOptions.autoPrint=config.autoOptions.enabled


                        console.log("config loadConfig ***** ",config)

                        this.applyConfig(config);
                    }
                } catch (e) {
                    console.error('Erreur lors du chargement de la configuration:', e);
                }
            },


            async show(tabvalue, typeimpression, options = {}) {
                this.tabvalue = tabvalue;
                this.typeimpression = typeimpression;

                // Charger la configuration sauvegardée

                STORAGE_KEY="ticket_print_config_v2_"+typeimpression
                HISTORY_KEY="ticket_print_history_v2_"+typeimpression


                this.loadConfig();
                this.loadHistory();

                // Fusionner les options passées en paramètre
                /*const printOptions = {
                    autoPrint: options.autoPrint ?? this.autoPrint ?? this.autoOptions.enabled,
                    delay: options.delay ?? this.autoPrintDelay ?? this.autoOptions.delay,
                    closeAfter: options.closeAfter ?? this.closeAfterPrint ?? this.autoOptions.closeAfter,
                    showPreview: options.showPreview ?? this.autoOptions.showPreview
                };*/

                const printOptions = {
                    autoPrint: options.autoPrint ?? this.autoOptions.enabled,
                    delay: options.delay ??  this.autoOptions.delay,
                    closeAfter: options.closeAfter ?? this.autoOptions.closeAfter,
                    showPreview: options.showPreview ?? this.autoOptions.showPreview
                };


                // Si impression directe sans aperçu
                if (printOptions.autoPrint && !printOptions.showPreview) {
                    // Afficher brièvement pour générer le contenu
                    this.isdisplay = true;

                    await this.$nextTick();

                    setTimeout(async () => {
                        await this.printTicket('printorderdatadeux',1);

                        if (printOptions.closeAfter) {
                            this.close();
                        }
                    }, printOptions.delay);
                }
                // Si impression auto avec aperçu
                else if (printOptions.autoPrint && printOptions.showPreview) {
                    this.isdisplay = true;

                    await this.$nextTick();

                    setTimeout(async () => {
                        await this.printTicket('printorderdatadeux',1);

                        if (printOptions.closeAfter) {
                            setTimeout(() => {
                                this.close();
                            }, 1000); // Petit délai pour que l'utilisateur voie que l'impression est lancée
                        }
                    }, printOptions.delay);
                }
                // Affichage normal sans impression auto
                else {
                    this.isdisplay = true;
                }
            },




            applyConfig(config) {
                if (!config) return;

                if (config.showSettings !== undefined) this.showSettings = config.showSettings;
                if (config.selectedCategory) this.selectedCategory = config.selectedCategory;
                if (config.selectedFormat) this.selectedFormat = config.selectedFormat;
                if (config.orientation) this.orientation = config.orientation;
                if (config.fontSize) this.fontSize = config.fontSize;
                if (config.fontFamily) this.fontFamily = config.fontFamily;
                if (config.fontWeight) this.fontWeight = config.fontWeight;
                if (config.lineHeight) this.lineHeight = config.lineHeight;
                if (config.margins !== undefined) this.margins = config.margins;
                if (config.density) this.density = config.density;
                if (config.copiesPerPage) this.copiesPerPage = config.copiesPerPage;
                if (config.customWidth) this.customWidth = config.customWidth;
                if (config.customHeight) this.customHeight = config.customHeight;
                if (config.customUnit) this.customUnit = config.customUnit;
                if (config.options) this.options = { ...this.options, ...config.options };
                if (config.printOptions) this.printOptions = { ...this.printOptions, ...config.printOptions };
                if (config.logoSize) this.logoSize = { ...config.logoSize };
                if (config.qrCodeSize) this.qrCodeSize = config.qrCodeSize;
                if (config.customFooterText) this.customFooterText = config.customFooterText;
                if (config.watermark) this.watermark = { ...this.watermark, ...config.watermark };
                if (config.autoOptions) this.autoOptions = { ...this.autoOptions, ...config.autoOptions };
                if (config.colors) this.colors = { ...this.colors, ...config.colors };
            },

            saveAsDefault() {
                this.saveConfig();
                toastr['success']('Configuration sauvegardée comme défaut') ||
                alert('Configuration sauvegardée comme défaut');
            },

            resetToDefaults(typeimpression) {
                this.showSettings = false;
                this.selectedCategory = 'pos';
                this.selectedFormat = 'pos-80mm';
                this.orientation = 'portrait';
                this.fontSize = 10;
                this.fontFamily = "'Courier New', monospace";
                this.fontWeight = '400';
                this.lineHeight = 1.3;
                this.margins = 5;
                this.density = 'normal';
                this.copiesPerPage = 1;
                this.customWidth = 80;
                this.customHeight = null;
                this.customUnit = 'mm';
                this.options = {
                    showLogo: true,
                    showQRCode: true,
                    showStoreInfo: true,
                    showFooter: true,
                    showDocType: true,
                    showItemNumber: true,
                    showUnitPrice: true,
                    showTaxInfo: true,
                    showAmountInWords: true,
                    showPoweredBy: true,
                    showBorder: true
                };
                this.printOptions = {
                    cutAfterPrint: true,
                    openCashDrawer: false,
                    silentPrint: false
                };
                this.logoSize = { width: 80, height: 70 };
                this.qrCodeSize = 60;
                this.customFooterText = '';
                this.watermark = {
                    enabled: false,
                    text: 'PAYÉ',
                    fontSize: 60,
                    opacity: 15,
                    rotation: -30,
                    color: '#000000',
                    position: 'center',
                    repeat: 'single'
                };
                this.autoOptions = {
                    enabled: false,
                    delay: 500,
                    closeAfter: false,
                    showPreview: true
                };
                this.colors = {
                    storeName: '#111827',
                    storeInfo: '#374151',
                    docType: '#111827',
                    labelText: '#6b7280',
                    valueText: '#111827',
                    tableHeaderBg: '#f3f4f6',
                    tableHeaderText: '#111827',
                    tableBodyText: '#111827',
                    totalBg: '#f9fafb',
                    netBg: '#e5e7eb',
                    netText: '#111827',
                    footerText: '#6b7280',
                    dividerColor: '#9ca3af',
                    ticketBg: '#ffffff',
                    borderColor: '#e5e7eb',
                };

                let MYSTORAGE_KEY="ticket_print_config_v2_"+typeimpression

                localStorage.removeItem(MYSTORAGE_KEY);
            },

            loadHistory() {
                try {
                    const saved = localStorage.getItem(HISTORY_KEY);
                    if (saved) {
                        this.printHistory = JSON.parse(saved);
                    }
                } catch (e) {
                    console.error('Erreur lors du chargement de l\'historique:', e);
                    this.printHistory = [];
                }
            },

            saveToHistory() {
                try {
                    this.printHistory.unshift(this.currentConfig);

                    if (this.printHistory.length > 10) {
                        this.printHistory = this.printHistory.slice(0, 10);
                    }

                    localStorage.setItem(HISTORY_KEY, JSON.stringify(this.printHistory));
                } catch (e) {
                    console.error('Erreur lors de la sauvegarde de l\'historique:', e);
                }
            },

            applyHistoryConfig(config) {
                this.applyConfig(config);
            },

            applyColorPreset(preset) {
                this.colors = { ...preset.colors };
            },

            async printTicket(refName = 'printorderdatadeux',directprint=0) {
                this.saveToHistory();
                this.saveConfig();

                const format = this.getSelectedFormat;
                const baseUrl = process.env.VUE_APP_URL || '';

                let styles = [
                    baseUrl + 'print/ticket-print-pro.css'
                ];

                if (format.type === 'paper' && this.orientation === 'landscape') {
                    styles.push(baseUrl + 'print/stylelandscape.css');
                }

                const scripts = ["https://cdn.tailwindcss.com"];

                await this.waitForRef(refName);

                setTimeout(() => {
                    const inlineStyle = [
                        `font-family:${this.fontFamily}`,
                        `font-size:${this.fontSize}px`,
                        `font-weight:${this.fontWeight}`,
                        `line-height:${this.lineHeight}`
                    ].join(';');
                    const customCss = this.generateCustomStyles();
                    const printContent = `<style>${customCss}</style><div class="print-content" style="${inlineStyle}">${this.$refs[refName].innerHTML}</div>`;
                    impression(printContent, styles, window.document.title, scripts);

                    // Ouverture du tiroir-caisse si l'option est activée (facture uniquement)
                    if (this.typeimpression === 'facture' && this.printOptions && this.printOptions.openCashDrawer) {
                        tryOpenDrawer({ silent: true });
                    }

                    if (directprint===0){
                      this.close();
                    }
                }, 800);




            },


            async printTicket_new() {
                this.saveToHistory();
                this.saveConfig();

                const format = this.getSelectedFormat;
                const baseUrl = process.env.VUE_APP_URL || '';

                let styles = [
                    baseUrl + 'print/ticket-print-pro.css'
                ];

                if (format.type === 'paper' && this.orientation === 'landscape') {
                    styles.push(baseUrl + 'print/stylelandscape.css');
                }

                styles.push(this.generateCustomStyles());

                const scripts = ["https://cdn.tailwindcss.com"];

                // Attendre que la ref soit disponible
                await this.waitForRef('printorderdatadeux');

                /*const printContent = this.$refs.printorderdatadeux.innerHTML;
                impression(printContent, styles, window.document.title, scripts);*/


              setTimeout(() => {
                const printContent = this.$refs.printorderdatadeux.innerHTML;
                impression(printContent, styles, window.document.title, scripts);

              }, 500);


            },

                // Nouvelle méthode helper
            waitForRef(refName, maxAttempts = 20, interval = 100) {
                return new Promise((resolve, reject) => {
                    let attempts = 0;

                    const check = () => {
                        attempts++;
                        if (this.$refs[refName]) {
                            resolve(this.$refs[refName]);
                        } else if (attempts >= maxAttempts) {
                            reject(new Error(`Ref "${refName}" not found after ${maxAttempts} attempts`));
                        } else {
                            setTimeout(check, interval);
                        }
                    };

                    check();
                });
            },



            generateCustomStyles() {
                const format = this.getSelectedFormat;
                const watermarkOpacity = this.watermark.opacity / 100;
                const densityPad = this.density === 'compact' ? '2px 4px' : (this.density === 'comfortable' ? '8px' : '4px 6px');
                const ticketPad = this.density === 'compact' ? '3px' : (this.density === 'comfortable' ? '12px' : '8px');

                return `
                    /* ====== PAGE ====== */
                    @page {
                        size: ${format.type === 'paper' ?
                    (this.orientation === 'landscape' ? `${format.height} ${format.width}` : `${format.width} ${format.height}`) :
                    `${format.width} auto`
                };
                        margin: ${this.margins}mm;
                    }

                    /* ====== CSS VARIABLES COULEURS ====== */
                    .ticket {
                        --c-store-name: ${this.colors.storeName};
                        --c-store-info: ${this.colors.storeInfo};
                        --c-doc-type: ${this.colors.docType};
                        --c-label: ${this.colors.labelText};
                        --c-value: ${this.colors.valueText};
                        --c-th-bg: ${this.colors.tableHeaderBg};
                        --c-th-text: ${this.colors.tableHeaderText};
                        --c-td: ${this.colors.tableBodyText};
                        --c-total-bg: ${this.colors.totalBg};
                        --c-net-bg: ${this.colors.netBg};
                        --c-net-text: ${this.colors.netText};
                        --c-footer: ${this.colors.footerText};
                        --c-divider: ${this.colors.dividerColor};
                        background: ${this.colors.ticketBg} !important;
                        border-color: ${this.colors.borderColor} !important;
                    }

                    /* ====== STYLES DE BASE ====== */
                    body, .print-content {
                        font-size: ${this.fontSize}px !important;
                        font-family: ${this.fontFamily} !important;
                        font-weight: ${this.fontWeight} !important;
                        line-height: ${this.lineHeight} !important;
                    }

                    .ticket {
                        width: ${format.type === 'pos' ? format.width : '100%'} !important;
                        max-width: 100% !important;
                        padding: ${this.density === 'compact' ? '3px' : (this.density === 'comfortable' ? '12px' : '8px')} !important;
                        position: relative !important;
                        overflow: hidden !important;
                    }

                    .items-table {
                        font-size: ${this.fontSize}px !important;
                    }

                    /* ====== DENSITÉ ====== */
                    .items-table th,
                    .items-table td {
                        padding: ${densityPad} !important;
                    }
                    .items-table.table-compact th,
                    .items-table.table-compact td {
                        padding: 2px 4px !important;
                    }
                    .items-table.table-comfortable th,
                    .items-table.table-comfortable td {
                        padding: 8px !important;
                    }

                    /* ====== COULEURS PAR SECTION ====== */
                    .store-name { color: var(--c-store-name) !important; }
                    .store-info p { color: var(--c-store-info) !important; }
                    .store-legal, .store-address, .store-phone { color: var(--c-store-info) !important; }
                    .doc-type-badge { color: var(--c-doc-type) !important; }
                    .label { color: var(--c-label) !important; font-weight: ${this.fontWeight} !important; }
                    .transaction-info { color: var(--c-value) !important; }
                    .items-table th { background-color: var(--c-th-bg) !important; color: var(--c-th-text) !important; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
                    .items-table td { color: var(--c-td) !important; }
                    .total-row { background-color: var(--c-total-bg) !important; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
                    .net-row { background-color: var(--c-net-bg) !important; color: var(--c-net-text) !important; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
                    .ticket-footer { color: var(--c-footer) !important; }
                    .divider { border-top-color: var(--c-divider) !important; }
                    .divider-light { border-top-color: var(--c-divider) !important; }

                    /* ====== STYLES DU FILIGRANE - IMPRESSION FORCÉE ====== */
                    ${this.watermark.enabled && this.watermark.text ? `
                        .watermark-container {
                            position: absolute !important;
                            left: 0 !important;
                            right: 0 !important;
                            top: 0 !important;
                            bottom: 0 !important;
                            display: flex !important;
                            align-items: ${this.watermark.position === 'top' ? 'flex-start' : (this.watermark.position === 'bottom' ? 'flex-end' : 'center')} !important;
                            justify-content: center !important;
                            pointer-events: none !important;
                            z-index: 0 !important;
                            overflow: hidden !important;
                            -webkit-print-color-adjust: exact !important;
                            print-color-adjust: exact !important;
                            color-adjust: exact !important;
                        }

                        .watermark-text {
                            font-size: ${this.watermark.fontSize}px !important;
                            font-weight: 700 !important;
                            color: ${this.watermark.color} !important;
                            opacity: ${watermarkOpacity} !important;
                            transform: rotate(${this.watermark.rotation}deg) !important;
                            text-transform: uppercase !important;
                            letter-spacing: 4px !important;
                            white-space: nowrap !important;
                            font-family: Arial, sans-serif !important;
                            -webkit-print-color-adjust: exact !important;
                            print-color-adjust: exact !important;
                            color-adjust: exact !important;
                        }

                        .watermark-pattern {
                            display: grid !important;
                            grid-template-columns: repeat(3, 1fr) !important;
                            grid-template-rows: repeat(3, 1fr) !important;
                            gap: 20px !important;
                            width: 200% !important;
                            height: 200% !important;
                            align-items: center !important;
                            justify-items: center !important;
                        }

                        .ticket-content {
                            position: relative !important;
                            z-index: 1 !important;
                        }
                    ` : ''}

                    ${this.printOptions.cutAfterPrint ? `
                        .ticket::after {
                            content: '';
                            display: block;
                            height: 20px;
                        }
                    ` : ''}

                    /* ====== RÈGLES D'IMPRESSION ====== */
                    @media print {
                        body {
                            margin: 0;
                            padding: 0;
                            -webkit-print-color-adjust: exact !important;
                            print-color-adjust: exact !important;
                            color-adjust: exact !important;
                        }

                        * {
                            -webkit-print-color-adjust: exact !important;
                            print-color-adjust: exact !important;
                            color-adjust: exact !important;
                        }

                        .no-print {
                            display: none !important;
                        }

                        .page-break {
                            page-break-before: always;
                        }

                        /* Force l'affichage du filigrane à l'impression */
                        .watermark-container,
                        .watermark-text {
                            visibility: visible !important;
                            opacity: ${watermarkOpacity} !important;
                            -webkit-print-color-adjust: exact !important;
                            print-color-adjust: exact !important;
                            color-adjust: exact !important;
                        }

                        ${this.copiesPerPage > 1 ? `
                            .ticket-copy {
                                display: inline-block !important;
                                width: ${100 / Math.min(2, this.copiesPerPage)}% !important;
                                vertical-align: top !important;
                                page-break-inside: avoid !important;
                            }
                        ` : ''}
                    }
            `;
            },

            previewFullScreen() {
                this.fullScreenContent = this.$refs.printorderdatadeux.innerHTML;
                this.showFullScreenPreview = true;
            },

            async copyToClipboard() {
                try {
                    const content = this.$refs.printorderdatadeux.innerText;
                    await navigator.clipboard.writeText(content);
                    toastr['success']('Contenu copié dans le presse-papier') ||
                     alert('Contenu copié dans le presse-papier');
                } catch (e) {
                    console.error('Erreur lors de la copie:', e);
                }
            },

            close() {
                this.isdisplay = false;
                this.$emit('closed', this.typeimpression);
            },

            selected(datavalue) {
                const elementSelectionne = { typ: this.typedoc, value: datavalue };
                this.$emit('elementSelectionne', elementSelectionne);
                this.isdisplay = false;
            },

            // Méthode pour impression directe sans ouvrir le modal
            async printDirect(tabvalue, typeimpression) {
                this.tabvalue = tabvalue;
                this.typeimpression = typeimpression;

                this.loadConfig();

                // Créer un élément temporaire pour l'impression
                this.isdisplay = true;

                await this.$nextTick();

                setTimeout(async () => {
                    await this.printTicket();
                    this.close();
                }, 500);
            },

            ExportExcel(type, name, fn, dl) {
                name = name + "_" + currentDateTime();
                var elt = this.$refs.exportable_table;
                ExportExcel(type, name, fn, dl, elt);
            }
        }
    };
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:92vh; overflow:hidden; }
.cf-dialog--xxl { max-width:1300px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

    /* Transition pour le panneau des paramètres */
    .slide-fade-enter-active {
        transition: all 0.3s ease-out;
    }

    .slide-fade-leave-active {
        transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .slide-fade-enter-from,
    .slide-fade-leave-to {
        transform: translateY(-10px);
        opacity: 0;
        max-height: 0;
    }

    .slide-fade-enter-to,
    .slide-fade-leave-from {
        max-height: 1000px;
    }

    .ticket {
        background: white;
        margin: 0 auto;
        position: relative;
        overflow: hidden;
    }

    /* Talon serveuse */
    .slip-spacer {
        height: 10px;
    }

    .server-slip-cutline {
        text-align: center;
        margin: 0 0 4px;
        color: #555;
        letter-spacing: 1px;
        font-style: italic;
    }

    .server-slip {
        padding: 4px 2px 6px;
    }

    .server-slip-header {
        text-align: center;
        border: 1px solid #333;
        padding: 3px 0;
        margin-bottom: 6px;
    }

    .server-slip-title {
        font-weight: bold;
        text-transform: uppercase;
        letter-spacing: 2px;
    }

    .server-slip-table {
        width: 100%;
        border-collapse: collapse;
    }

    .server-slip-table .slip-label {
        font-weight: bold;
        padding: 2px 0;
        white-space: nowrap;
    }

    .server-slip-table .slip-dots {
        width: 99%;
        border-bottom: 1px dotted #999;
        padding: 0 3px;
    }

    .server-slip-table .slip-value {
        padding: 2px 0 2px 4px;
        text-align: right;
        white-space: nowrap;
    }

    .slip-amount-separator {
        text-align: center;
        color: #555;
        letter-spacing: 1px;
        margin: 4px 0 2px;
        overflow: hidden;
    }

    .slip-amount-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: bold;
        padding: 3px 0;
    }

    .slip-amount-label {
        text-transform: uppercase;
        letter-spacing: 1px;
    }

    .slip-amount-value {
        font-weight: bold;
    }

    .divider {
        border-top: 1px dashed var(--c-divider, #9ca3af);
        margin: 8px 0;
    }

    .divider-light {
        border-top: 1px dotted var(--c-divider, #9ca3af);
        margin: 4px 0;
    }

    @media screen and (max-width: 768px) {
        .cf-dialog--xxl {
            max-width: 100% !important;
        }

        .ticket {
            width: 100% !important;
            max-width: 100% !important;
        }
    }

    .config-panel {
        animation: fadeIn 0.2s ease-in-out;
    }

    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }

    .items-table {
        border-collapse: collapse;
        width: 100%;
    }

    .items-table th,
    .items-table td {
        border: 1px solid #d1d5db;
        padding: 4px 6px;
        text-align: left;
    }

    .items-table th {
        background-color: var(--c-th-bg, #f3f4f6);
        color: var(--c-th-text, #111827);
        font-weight: 600;
    }

    .items-table td {
        color: var(--c-td, #111827);
    }

    .store-name {
        color: var(--c-store-name, #111827);
    }

    .store-info p {
        color: var(--c-store-info, #374151);
    }

    .doc-type-badge {
        color: var(--c-doc-type, #111827);
    }

    .transaction-info {
        color: var(--c-value, #111827);
    }

    .total-row {
        background-color: var(--c-total-bg, #f9fafb);
    }

    .net-row {
        background-color: var(--c-net-bg, #e5e7eb);
        color: var(--c-net-text, #111827);
    }

    .ticket-footer {
        color: var(--c-footer, #6b7280);
    }

    .items-table .col-num {
        width: 30px;
        text-align: center;
    }

    .items-table .col-qty,
    .items-table .col-price,
    .items-table .col-total {
        text-align: right;
        white-space: nowrap;
    }

    .items-table tfoot tr {
        background-color: #f9fafb;
    }

    .items-table .net-row {
        background-color: var(--c-net-bg, #e5e7eb);
        color: var(--c-net-text, #111827);
    }

    .items-table .total-row {
        background-color: var(--c-total-bg, #f9fafb);
    }

    .label {
        font-weight: 500;
        color: var(--c-label, #6b7280);
    }

    .tax-info {
        font-size: 0.85em;
        color: #6b7280;
    }

    .variant-info {
        font-style: italic;
        color: #4b5563;
    }

    .note-warning {
        background-color: #fef3c7;
        border: 1px solid #f59e0b;
        padding: 8px;
        border-radius: 4px;
    }

    .mecef-section {
        font-size: 0.9em;
    }

    .mecef-info .conformity {
        color: #059669;
        font-weight: 500;
    }

    .copy-separator {
        margin: 15px 0;
        text-align: center;
    }

    .cut-line {
        color: #9ca3af;
        font-size: 10px;
        letter-spacing: 2px;
    }

    .qrcode-img {
        display: block;
        border: 1px solid #e5e7eb;
        padding: 2px;
        background: white;
    }

    .badge {
        display: inline-block;
        padding: 2px 8px;
        border-radius: 4px;
        font-size: 12px;
    }

    .preview-controls {
        padding: 4px 8px;
        background: #f9fafb;
        border-radius: 4px;
    }

    /* Styles du filigrane */
    .watermark-container {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: none;
        z-index: 0;
        overflow: hidden;
    }

    .watermark-top {
        align-items: flex-start;
        padding-top: 20px;
    }

    .watermark-bottom {
        align-items: flex-end;
        padding-bottom: 20px;
    }

    .watermark-text {
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 4px;
        white-space: nowrap;
        user-select: none;
        font-family: Arial, sans-serif;
    }

    .watermark-pattern {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: repeat(3, 1fr);
        gap: 20px;
        width: 200%;
        height: 200%;
        align-items: center;
        justify-items: center;
    }

    .watermark-preview {
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 2px;
        white-space: nowrap;
    }

    .ticket-content {
        position: relative;
        z-index: 1;
    }

    /* Quick toolbar styles */
    .quick-toolbar {
        border: 1px solid #e5e7eb;
    }

    /* Impression */
    @media print {
        .ticket {
            border: none !important;
            box-shadow: none !important;
        }

        .no-print {
            display: none !important;
        }

        .page-break {
            page-break-before: always;
        }

        /* Force l'affichage du filigrane */
        .watermark-container,
        .watermark-text {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
        }
    }

    .toggle-switch {
        display: inline-flex;
        align-items: center;
        cursor: pointer;
    }

    .toggle-switch input {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
    }

    .toggle-slider {
        position: relative;
        width: 36px;
        height: 20px;
        background-color: #d1d5db;
        border-radius: 20px;
        transition: background-color 0.3s;
    }

    .toggle-slider::after {
        content: '';
        position: absolute;
        top: 2px;
        left: 2px;
        width: 16px;
        height: 16px;
        background-color: white;
        border-radius: 50%;
        transition: transform 0.3s;
    }

    /* État activé */
    .toggle-switch input:checked + .toggle-slider {
        background-color: #3b82f6;
    }

    .toggle-switch input:checked + .toggle-slider::after {
        transform: translateX(16px);
    }

    /* Focus */
    .toggle-switch input:focus + .toggle-slider {
        box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.3);
    }

    .toggle-label {
        margin-left: 8px;
        font-size: 14px;
    }

    /* ====== SÉLECTEURS DE COULEUR ====== */
    .color-group {
        transition: box-shadow 0.2s;
    }

    .color-group:hover {
        box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    }

    .color-picker-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 6px;
    }

    .color-picker-row label {
        font-size: 11px;
        color: #6b7280;
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .color-input-pair {
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .color-swatch {
        width: 28px;
        height: 24px;
        padding: 1px;
        border: 1px solid #d1d5db;
        border-radius: 4px;
        cursor: pointer;
        background: none;
    }

    .color-hex {
        width: 70px;
        font-size: 11px;
        font-family: monospace;
        padding: 2px 4px;
        border: 1px solid #d1d5db;
        border-radius: 4px;
        height: 24px;
    }

    .color-hex:focus {
        outline: none;
        border-color: #3b82f6;
    }










</style>